/**
 * Build-time app variant. Two artifacts are built from this codebase:
 *
 *   npm run build         -> user build  (VITE_APP_VARIANT unset/user)
 *   npm run build:admin   -> admin build (VITE_APP_VARIANT=admin)
 *
 * `import.meta.env.VITE_APP_VARIANT` is statically replaced by Vite, so
 * branches behind IS_ADMIN_BUILD are dead-code-eliminated in the user build —
 * admin-only routes, chunks, and UI never ship to general users.
 *
 * The admin build additionally gates admin UI on the server-authoritative
 * `user.admin` flag (see useAdminUI in @/stores): a non-admin signing into the
 * admin deployment gets the general-user experience, and the API returns 403
 * on admin endpoints regardless of what any client renders.
 */
export const IS_ADMIN_BUILD = import.meta.env.VITE_APP_VARIANT === 'admin';
